import Vue from 'vue'

Vue.directive('reClick', {
	inserted: function (el, binding) {
		el.addEventListener('click', () => {
			if (!el.disabled) {
				el.disabled = true;
				setTimeout(() => {
					el.disabled = false;
				}, binding.value || 1500)
			}
		});
	}
})

export default { Vue }


// WEBPACK FOOTER //
// ./src/libs/directive.js